import React from 'react';
interface VideoHeroProps {
  videoUrl?: string;
  children?: React.ReactNode;
  className?: string;
}
export function VideoHero({
  videoUrl,
  children,
  className = ''
}: VideoHeroProps) {
  const defaultVideoUrl = 'https://3dots.b-cdn.net/3-dot-background-video-desktop-new.mp4';
  return <div className={`relative w-full min-h-screen overflow-hidden ${className}`} data-id="element-38">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full" data-id="element-39">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-40">
          <source src={videoUrl || defaultVideoUrl} type="video/mp4" data-id="element-41" />
        </video>
        {/* Dark overlay for text legibility */}
        <div className="absolute inset-0 bg-black/50" data-id="element-42" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full min-h-screen" data-id="element-43">{children}</div>
    </div>;
}